import { render, staticRenderFns } from "./IntakeAddress.vue?vue&type=template&id=49f4094a&scoped=true&lang=pug&"
import script from "./IntakeAddress.vue?vue&type=script&lang=js&"
export * from "./IntakeAddress.vue?vue&type=script&lang=js&"
import style0 from "./IntakeAddress.vue?vue&type=style&index=0&id=49f4094a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f4094a",
  null
  
)

/* custom blocks */
import block0 from "./IntakeAddress.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports